import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import user from "assets/images/icons/user.svg";
import users from "assets/images/icons/users.svg";
import userBlack from "assets/images/icons/userBlack.svg";
import info2 from "assets/images/icons/info2.svg";
import users2 from "assets/images/icons/users2.svg";
import retention from "assets/images/icons/retention.svg";
import churn from "assets/images/icons/churn.svg";
import numberOfUsersTooltip from "assets/images/numberOfUsersTooltip.png";
import churnTooltip from "assets/images/churnTooltip.png";
import retentionRateTooltip from "assets/images/retentionRateTooltip.png";
import { DashboardOverViewRetentionRateIcon, DashboardOverViewUserIcon, DashboardOverViewUsers2Icon, DashboardOverViewUsersIcon } from "components/common/SVGIcons";

const UserActivity = () => {
  const { t } = useTranslation();
  const { overviewDashboard } = useSelector((state) => state.Dashboards);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipType, setTooltipType] = useState(null);
  const tooltipRef = useRef(null);
  const { brandInfo } = useSelector((state) => state.auth);
  const { primaryColor } = brandInfo?.theme?.themeColors  || {};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <Col lg={6}>
      <div className="inner_section">
        <div className="title_section">
          <DashboardOverViewUserIcon width={24} height={24} color={primaryColor} />
          <h2 className="fs_20 text_black">{t("User Activity")}</h2>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <DashboardOverViewUsersIcon color={primaryColor} />
            <div className="g_between position-relative">
              <h2 className="fs_14 text_black mt-2">{t("Number of Users")}</h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => {
                  setTooltipType(1);
                  setShowTooltip(!showTooltip);
                }}
              />
              {showTooltip && tooltipType === 1 && (
                <img
                  src={numberOfUsersTooltip}
                  width={500}
                  height={226}
                  alt="info"
                  className="c_p tooltip_img number_of_user_tooltip"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.totalUsers?.toLocaleString(
                  "en-US"
                )}
                <img
                  src={userBlack}
                  alt="user"
                  width={18}
                  height={18}
                  className="mx-2"
                />
              </h2>
            </div>
            <p className="text_dark_gray fs_12">
              {t("Active user:")}{" "}
              {overviewDashboard?.customers?.totalActiveUsers?.toLocaleString(
                "en-US"
              )}{" "}
              - ( {overviewDashboard?.customers?.totalActiveUsersPercentage}% )
            </p>
          </div>
          <div className="single_item">
            <DashboardOverViewUsers2Icon color={primaryColor}/>
            <h2 className="fs_14 text_black mt-2">
              {t("New Users by Referral Code")}
            </h2>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.newReferralUsers?.toLocaleString(
                  "en-US"
                )}
              </h2>
            </div>
          </div>
        </div>
        <div className="sub_items">
          <div className="single_item">
            <DashboardOverViewRetentionRateIcon color={primaryColor} />
            <div className="g_between position-relative" ref={tooltipRef}>
              <h2 className="fs_14 text_black mt-2">{t("Retention Rate")}</h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => {
                  setTooltipType(2);
                  setShowTooltip(!showTooltip);
                }}
              />
              {showTooltip && tooltipType === 2 && (
                <img
                  src={retentionRateTooltip}
                  width={650}
                  height={553}
                  alt="info"
                  className="c_p tooltip_img retention_tooltip"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.repeatUsersPercentage}%
              </h2>
            </div>
            <p className="text_dark_gray fs_12">
              {t("Returned Users: ")}{" "}
              {overviewDashboard?.customers?.repeatUsersCount?.toLocaleString(
                "en-US"
              )}
            </p>
          </div>
          <div className="single_item">
            <img src={churn} width={24} height={24} alt="churn" />
            <div className="g_between position-relative">
              <h2 className="fs_14 text_black mt-2">{t("Churn Rate")}</h2>
              <img
                src={info2}
                width={16}
                height={16}
                alt="info"
                className="c_p"
                onClick={() => {
                  setTooltipType(3);
                  setShowTooltip(!showTooltip);
                }}
              />
              {showTooltip && tooltipType === 3 && (
                <img
                  src={churnTooltip}
                  width={400}
                  height={687}
                  alt="info"
                  className="c_p tooltip_img churn_tooltip"
                />
              )}
            </div>
            <div className="d-flex align-items-center gap-2 mt-4">
              <h2 className="fs_24 text_black ">
                {overviewDashboard?.customers?.churnRate}%
              </h2>
            </div>
            <p className="text_dark_gray fs_12">
              {t("Churned Users:")}{" "}
              {overviewDashboard?.customers?.churnedUsers?.toLocaleString(
                "en-US"
              )}
            </p>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default UserActivity;
